var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimeClock',{attrs:{"client-id":_vm.clientId,"hideTitle":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }